import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';

export class HideFiltersFilterWidget extends FilterGroup {
    constructor(container: string) {
        super();
        this.id = 'hideFilters';
        this.name = '';
        this.icon = '';
        this.resource = '';
        this.container = container;
        this.controller = new FiltersController();
    }

    html(): void {
        this.isDestroyed = false;
        let html = this.filtersHtml() + `
        <div>
            ${!FilterGroup.previewAuto ? `
                <button id="startPreviewAuto" class="btn-default" title="Activer preview auto">
                    <i class="fas fa-lg fa-eye-slash"></i>
                    <span style="margin-left: 10px;">Activer preview auto</span>
                </button>
            ` : ''}
            ${FilterGroup.previewAuto ? `
                <button id="stopPreviewAuto" class="btn-default" title="Désactiver preview auto">
                    <i class="fas fa-lg fa-eye"></i>
                    <span style="margin-left: 10px;">Désactiver preview auto</span>
                </button>
            ` : ''}
        </div>
        `;

        setTimeout(() => {
            this.controller.addEventListener('mousedown', () => {
                FilterGroup.startStopPreviewAuto();
            }, 'startPreviewAuto');
            this.controller.addEventListener('mousedown', () => {
                FilterGroup.startStopPreviewAuto();
            }, 'stopPreviewAuto');
        });

        let container = document.getElementById(this.container);
        if (!container) {
            return;
        }
        container.innerHTML = html;
    }

    destroy(): void {
        super.destroy();
    }
}